import { supabase } from './supabaseClient'

function getBrowser() { /* tal cual lo tienes en Login.jsx */ }
function getDeviceInfo() { /* tal cual lo tienes en Login.jsx */ }

export async function registerSession(userId) {
  try {
    const token = crypto.randomUUID()
    const { error } = await supabase.from('active_sessions').insert({
      user_id: userId,
      session_token: token,
      browser: getBrowser(),
      device_info: getDeviceInfo(),
      last_seen: new Date().toISOString(),
      created_at: new Date().toISOString(),
    })
    if (!error) localStorage.setItem('session_token_' + userId, token)
  } catch (err) {
    console.error('Error registrando sesión:', err)
  }
}

// Devuelve 'ok' | 'created' | 'revoked' | 'unknown'
export async function ensureActiveSession(userId) {
  try {
    const token = localStorage.getItem('session_token_' + userId)

    // No hay token local pero la sesión de Supabase es válida: crear fila nueva
    if (!token) {
      await registerSession(userId)
      return 'created'
    }

    const { data, error } = await supabase
      .from('active_sessions')
      .select('id')
      .eq('session_token', token)
      .eq('user_id', userId)
      .maybeSingle()

    if (error) return 'unknown' // sin red u otro error: NO cerrar sesión

    if (!data) return 'revoked' // la fila no existe: la cerraste desde Perfil

    await supabase
      .from('active_sessions')
      .update({ last_seen: new Date().toISOString() })
      .eq('id', data.id)
    return 'ok'
  } catch {
    return 'unknown'
  }
}